import React, { useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import classnames from 'classnames'
import { Content, Text, TextInput, Label, Button, Pane, Flex } from '@leverege/ui-elements'

import { JsonEditorDialog, InsetSection } from '~/views'

import S from './EnumEditorStyle.css'

function EnumEditor( { item, itemActions, dispatch, full, showTitle = true } ) {
  if ( !item ) return null

  const [ showJsonEditor, setShowJsonEditor ] = useState( false )
  const { type, name, description, metadata, locked = false, createdAt } = item
  const stringifiedMetadata = metadata ? JSON.stringify( metadata, null, 2 ) : null
  const onChange = ( { value, data } ) => {
    let nVal = data === 'name' && !value ? type : value
    nVal = typeof nVal === 'string' ? nVal.trim() : nVal
    dispatch( itemActions( type ).update( { [data] : nVal } ) )
    setShowJsonEditor( false )
  }
  return (
    <Pane className={classnames( S.editorPanel, { [S.full] : full } )}>
      <Content>
        {showTitle && (
          <Content.Header>
            <Pane className={S.title} variant="screenTitle">
              <Text variant="caption">Enum Type</Text>
              <Text variant="cardTitle">{type}</Text>
            </Pane>
          </Content.Header>
        ) }
        <Content.Area>
          <Pane className={S.formBody} variant="formBody">
            <div className={S.inputGroup}>
              <Label variant="input">Name</Label>
              <TextInput
                onChange={onChange}
                eventData="name"
                value={name} />
            </div>
            <div className={S.inputGroup}>
              <Label variant="input">Description</Label>
              <TextInput onChange={onChange} eventData="description" value={description} />
            </div>
            <div className={S.inputGroup}>
              <Flex direction="row" className={S.metadata}>
                <Label style={{ marginRight : 8 }}>Metadata</Label>
                <Button variant="secondarySmall" onClick={() => setShowJsonEditor( true )}>
                  {stringifiedMetadata ? 'Edit' : 'Add'}
                </Button>
              </Flex>
              <InsetSection>
                {stringifiedMetadata ? <pre>{stringifiedMetadata}</pre> : 'No Metadata'}
              </InsetSection>
              <JsonEditorDialog
                title="Enum Metadata"
                message="Enter the JSON object for the enum metadata"
                show={showJsonEditor}
                onOk={value => onChange( { data : 'metadata', value } )}
                onCancel={() => setShowJsonEditor( false )}
                value={metadata} />
            </div>
            <div className={S.inputGroup}>
              <Text>Created {moment( createdAt ).format( 'lll' )}</Text>
            </div>
          </Pane>
        </Content.Area>
      </Content>
    </Pane>
  )
}

export default connect( ( state, props ) => {
  const { itemActions, enumType } = props
  const baseActions = itemActions( enumType )
  const item = typeof baseActions.getEnum === 'function' ?
    baseActions.getEnum( state ) :
    baseActions.getResourceEnum( state )
  return {
    item
  }
} )( EnumEditor )
